import { render, staticRenderFns } from "./GFullWidthTemplate.vue?vue&type=template&id=d9e76d92&"
import script from "./GFullWidthTemplate.vue?vue&type=script&lang=ts&"
export * from "./GFullWidthTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./GFullWidthTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports